<template>
  <ModalDialog :show="show" @close="cancel" target-class="modal__card--mini">
    <div class="card-wizard">
      <div class="card-wizard__title">
        <h3 class="header-3">{{ $t("mylist.widgetCollaboratorNamePromptTitle") }}</h3>
        <div class="card-wizard__subtitle">
          {{ $t("mylist.widgetCollaboratorNamePromptSubtitle") }}
        </div>
      </div>
      <form class="card-wizard__container" @submit.prevent="save">
        <div class="bb-form-item bb-form-item--left w-100">
          <label for="collaboratorInviterName" class="bb-form-label">
            {{ $t("mylist.widgetCollaboratorNamePromptLabel") }}
          </label>
          <input
            v-model="name"
            class="bb-form"
            type="text"
            maxlength="256"
            name="collaboratorInviterName"
            id="collaboratorInviterName"
            :placeholder="$t('mylist.widgetNamePlaceholder')"
            @blur="dirty = true"
          />
          <div class="bb-form-error" v-show="nameHasError">
            {{ $t("generic.field_is_required") }}
          </div>
        </div>

        <div class="card-wizard__actions">
          <loading-button v-if="loading"></loading-button>
          <button
            v-else
            type="submit"
            class="button button--primary button--block"
            :disabled="disabled"
          >
            {{ $t("mylist.widgetCollaboratorNamePromptSave") }}
          </button>
          <button
            type="button"
            class="button button--secondary button--block mar-t-fs-smaller"
            :disabled="loading"
            @click="cancel"
          >
            {{ $t("generic.cancel") }}
          </button>
        </div>
      </form>
    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from "./ui/ModalDialog";
import LoadingButton from "./LoadingButton";

// Shown before sending a collaborator invitation when the current user has
// no name saved yet - the invitee sees the inviter's name on the invite, so
// we need it before the invitation call can go out.
export default {
  name: "CollaboratorNamePromptModal",
  components: {
    ModalDialog,
    "loading-button": LoadingButton,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: "",
      dirty: false,
      loading: false,
    };
  },
  computed: {
    nameHasError() {
      return this.dirty && this.name.trim() === "";
    },
    disabled() {
      return this.name.trim() === "";
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.name = "";
        this.dirty = false;
      }
    },
  },
  methods: {
    async save() {
      if (this.disabled) return;
      this.loading = true;
      const name = this.name.trim();
      try {
        await this.$store.dispatch("updateName", name);
      } catch {
        this.loading = false;
        this.$emit("error");
        return;
      }
      this.$store.commit("updateUserField", { field: "name", value: name });
      this.loading = false;
      this.$emit("saved", name);
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>
